export default __webpack_public_path__ + "static/media/36I-102740_-15813_0.e99dda7b.jpg";